<template>
  <div>
    <div style="text-align: center;" v-if="!isOperator && !isAdmin">{{ $t('noData') }}</div>
    <AutoRow v-if="isOperator" :data="[
      {
        text: '待补录信息',
        value: data.need_supplement_customers_count,
        to: { name: 'customers.index', query: { need_supplement_information: true, related: true } },
      },
      {
        text: '待触达',
        value: data.need_follow_customers_count,
        to: { name: 'customers.index', query: { need_follow: true, related: true } },
      },
      {
        text: '待转接确认',
        value: data.pending_approve_customers_count,
        to: { name: 'customers.index', query: { pending_approve: true } },
      }
    ]" />
    <div v-if="isOperator || isAdmin">
      <AutoChartRow v-if="summary" :data="[
        {
          text: '不同等级客户统计',
          options: formattedPieOptions(
            summary.customers_count_of_customer_level,
            '数量'
          )
        }
      ]" />
      <el-form :inline="true" :model="queryForm" v-loading="statisticsLoading">
        <Period
          :period.sync="queryForm.period"
          :created_gteq_date.sync="queryForm.created_gteq_date"
          :created_lteq_date.sync="queryForm.created_lteq_date"
        />
        <el-form-item label="客户">
          <bean-select
            v-model="queryForm.customer_id_eq"
            :clearable="true"
            :xRemotePreload="fetchCustomerOptions"
            :xRemoteSearch="fetchCustomerOptions"
          />
        </el-form-item>
        <el-form-item label="业务员">
          <bean-select
            v-model="queryForm.customer_user_id_eq"
            :clearable="true"
            :xRemotePreload="fetchUserOptions"
            :xRemoteSearch="fetchUserOptions"
          />
        </el-form-item>
        <el-form-item label="渠道">
          <bean-select
            v-model="queryForm.customer_customer_source_id_in"
            :clearable="true"
            :multiple="true"
            :xRemotePreload="fetchCustomerSourceOptions"
            :xRemoteSearch="fetchCustomerSourceOptions"
          />
        </el-form-item>
        <el-form-item label="级别">
          <bean-select
            v-model="queryForm.customer_customer_level_id_eq"
            :clearable="true"
            :xRemotePreload="fetchCustomerLevelOptions"
            :xRemoteSearch="fetchCustomerLevelOptions"
          />
        </el-form-item>
        <el-form-item label="业务模式">
          <bean-select
            v-model="queryForm.customer_customer_business_models_id_eq"
            :clearable="true"
            :xRemotePreload="fetchCustomerBusinessModelOptions"
            :xRemoteSearch="fetchCustomerBusinessModelOptions"
          />
        </el-form-item>
        <el-form-item label="标签">
          <bean-select
            v-model="queryForm.customer_customer_tags_id_eq"
            :clearable="true"
            :xRemotePreload="fetchCustomerTagOptions"
            :xRemoteSearch="fetchCustomerTagOptions"
          />
        </el-form-item>
        <el-form-item label="店铺">
          <bean-select
            v-model="queryForm.shop_id_eq"
            :clearable="true"
            :xRemotePreload="fetchShopOptions"
            :xRemoteSearch="fetchShopOptions"
          />
        </el-form-item>
        <el-form-item label="团队/小组">
          <app-team-tree-select
            v-model="queryForm.user_team_id_eq"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="statisticsLoading" @click="fetchStatistics(false)">查询</el-button>
          <el-tooltip class="item" effect="light" placement="right">
            <div slot="content">
              触达率 = 时间范围内触达的客户 / 总客户数<br/>
              新客首单转化率 = 时间范围内首单的新客户 / 时间范围内总的新客户数<br/>
              总转化率 = 时间范围内总下单客户数 / 总客户数<br/>
              老客户复购率 = 时间范围内下单的老客户数量 / (总客户数-时间范围内创建的新客户数)<br/>
              客单价 = 时间范围内的总金额 / 时间范围内的下单客户数
            </div>
            <i class="statistics-info el-icon-info"></i>
          </el-tooltip>
          <el-button type="primary" :loading="statisticsLoading" @click="fetchStatistics(true)">刷新查询</el-button>
          <el-tooltip class="item" effect="light" placement="right">
            <div slot="content">
              刷新查询会忽略缓存并重新计算数据<br/>
            </div>
            <i class="statistics-info el-icon-info"></i>
          </el-tooltip>
          <!-- <bean-export-button url="/dashboard/statistics_details" :params="queryForm" fileName="统计数据.xlsx" /> -->
        </el-form-item>
      </el-form>
      <AutoRow v-if="statistics" :data="[
        {
          text: '新客户数',
          value: statistics.total_new_customers_count,
          to: { name: 'customers.index', query: this.customerQuery },
        }
      ]" />
      <AutoChartRow v-if="statistics" :data="[
        {
          text: '客户数统计',
          options: formattedBarOptions({
            '新客户数量': statistics.new_customer_count_trend,
          })
        }
      ]" />
      <AutoRow v-if="statistics" :data="[
        {
          text: '订单数',
          value: sum(statistics.order_count_trend),
          to: { name: 'jushuitan_orders.index', query: jushuitanOrderQuery },
        },
        {
          text: '售后数',
          value: sum(statistics.after_sale_count_trend),
          to: { name: 'jushuitan_after_sales.index', query: jushuitanAfterSaleQuery },
        },
        {
          text: '订单金额',
          value: sum(statistics.order_amount_trend),
          // to: { name: 'jushuitan_orders.index', query: jushuitanOrderQuery },
        },
        {
          text: '售后金额',
          value: sum(statistics.after_sale_amount_trend),
          // to: { name: 'jushuitan_after_sales.index', query: jushuitanAfterSaleQuery },
        },
      ]" />
      <AutoChartRow v-if="statistics" :data="[
        {
          text: '订单数统计',
          options: formattedBarOptions({
            '订单数量': statistics.order_count_trend,
          })
        },
        {
          text: '售后数统计',
          options: formattedBarOptions({
            '售后数量': statistics.after_sale_count_trend,
          })
        },
      ]" />
      <AutoChartRow v-if="statistics" :data="[
        {
          text: '订单金额统计',
          options: formattedBarOptions({
            '订单金额': statistics.order_amount_trend,
          })
        },
        {
          text: '售后金额统计',
          options: formattedBarOptions({
            '售后金额': statistics.after_sale_amount_trend,
          })
        },
      ]" />
      <el-row :gutter="15" v-if="statistics">
        <el-col :span="12">
          <bean-table :height="null" :value="statistics.range_order_amount_per_user" :columns="userColumns('order_amount')" />
        </el-col>
        <el-col :span="12">
          <bean-table :height="null" :value="statistics.range_after_sale_amount_per_user" :columns="userColumns('after_sale_amount')" />
        </el-col>
      </el-row>
      <AutoChartRow v-if="statistics" :data="[
        {
          text: '触达率统计',
          options: formattedRatioOptions({
            '触达率': statistics.follow_ratio_trend,
          })
        },
        {
          text: '客单价统计',
          options: formattedBarOptions({
            '客单价': statistics.average_spending_per_customer_trend,
          })
        },
      ]" />
      <el-row :gutter="15" v-if="statistics">
        <el-col :span="12">
          <bean-table :height="null" :value="statistics.range_followed_ratio_per_user" :columns="userColumns('followed_ratio')" />
        </el-col>
        <el-col :span="12">
          <bean-table :height="null" :value="statistics.range_average_spending_per_customer_per_user" :columns="userColumns('average_spending_per_customer')" />
        </el-col>
      </el-row>
      <AutoChartRow v-if="statistics" :data="[
        {
          text: '新客首单转化率统计',
          options: formattedRatioOptions({
            '新客首单转化率': statistics.first_ordered_ratio_trend,
          })
        },
        {
          text: '老客户复购率统计',
          options: formattedRatioOptions({
            '老客户复购率': statistics.more_ordered_ratio_trend,
          })
        },
        {
          text: '总转化率统计',
          options: formattedRatioOptions({
            '总转化率': statistics.ordered_ratio_trend,
          })
        },
      ]" />
      <el-row :gutter="15" v-if="statistics">
        <el-col :span="8">
          <bean-table :height="null" :value="statistics.range_first_ordered_ratio_per_user" :columns="userColumns('first_ordered_ratio')" />
        </el-col>
        <el-col :span="8">
          <bean-table :height="null" :value="statistics.range_more_ordered_ratio_per_user" :columns="userColumns('more_ordered_ratio')" />
        </el-col>
        <el-col :span="8">
          <bean-table :height="null" :value="statistics.range_ordered_ratio_per_user" :columns="userColumns('ordered_ratio')" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Mixins } from 'vue-property-decorator';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import moment from 'moment';
import Utils from '@/components/utils.vue';
import { columnsExtend as userColumnsExtend  } from '@/admin_grapes/users.js';
import CustomerDialog from '@/components/customer-dialog.vue';
import Period from './components/period.vue';
import { displayText } from '@/custom_models_extend';

const Result = {
  functional: true,
  render(h, context) {
    const { title, value, percentValue = false, groups = [] } = context.props;
    const result = percentValue ? `${(value * 100).toFixed(2)}%` : value;
    return (
      <CustomerDialog
        trigger="hover"
        title={`${title} - ${result}`}
        scopedSlots={{
          trigger: ({ open }) => {
            return (
              <div onClick={open} style="cursor: pointer;">
                { result }
                &nbsp;
                <i class="el-icon-info" />
              </div>
            )
          }
        }}
        groups={groups}
      />
    )
  }
}

const colors = ['#187498', '#AC66CC', '#F9D923', '#EB5353', '#36AE7C'];
const AutoRow = {
  functional: true,
  render(h, context) {
    let { data } = context.props;
    data = _.filter(data, datum => !_.isNil(datum.value))
    if (_.size(data) === 0) {
      return <div></div>
    }

    const span = 24 / _.size(data);
    return (
      <el-row gutter={15}>
        {
          _.map(data, datum => {
            return (
              <el-col span={span}>
                <el-card>
                  <div slot="header">{datum.text}</div>
                  <div class="statistics">
                    { datum.to ? <bean-link keepNode target="_blank" can={datum.can} to={datum.to}>{ datum.value }</bean-link> : <span>{datum.value}</span> }
                  </div>
                </el-card>
              </el-col>
            )
          })
        }
      </el-row>
    )
  }
};

const AutoChartRow = {
  functional: true,
  render(h, context) {
    let { data } = context.props;
    data = _.filter(data, datum => !_.isNil(datum.options))
    if (_.size(data) === 0) {
      return <div></div>
    }

    const span = 24 / _.size(data);
    return (
      <el-row gutter={15}>
        {
          _.map(data, datum => {
            return (
              <el-col span={span}>
                <el-card>
                  <div slot="header">{datum.text}</div>
                  <div>
                    <ECharts options={datum.options} style="width:100%" />
                  </div>
                </el-card>
              </el-col>
            )
          })
        }
      </el-row>
    )
  }
};

@Component({
  components: {
    ECharts,
    AutoRow,
    AutoChartRow,
    Period
  }
})
export default class ApplicationHome extends Mixins(Vue, Utils) {
  year = moment().year();
  queryForm = {
    created_gteq_date: undefined,
    created_lteq_date: undefined,
    period: 'day',
    customer_id_eq: undefined,
    user_team_id_eq: undefined,
  }
  statistics = null
  statisticsLoading = false
  summary = null
  data = {
  }

  chartBaseConfig = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: []
  }

  created() {
    if (this.roleKind === 'salesman' || this.roleKind === 'customer_service') {
      this.queryForm.customer_user_id_eq = this.currentUser.id;
    }
  }

  async mounted() {
    if (this.isOperator) {
      this.data = await this.$request.get('/dashboard/application')
    }
    await this.fetchSummary()
    // await this.fetchStatistics()
  }

  async fetchSummary() {
    this.summary = await this.$request.get('/dashboard/summary')
  }

  async fetchStatistics(force) {
    try {
      this.statistics = null
      this.statisticsLoading = true
      this.statistics = await this.$request.get('/dashboard/statistics', { params: { ...this.queryForm, force } }, { timeout: 15 * 60 * 1000 })
    } catch (error) {
      console.error(error)
    } finally {
      this.statisticsLoading = false
    }
  }

  async fetchCustomerOptions(keyword) {
    if (keyword) {
      return (await this.$request.get('/customers/read_options', { keyword, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
    } else {
      return (await this.$request.get('/customers/read_options', { per_page: 100, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
    }
  }

  async fetchUserOptions(keyword) {
    if (keyword) {
      return (await this.$request.get('/users/read_options', { keyword, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
    } else {
      return (await this.$request.get('/users/read_options', { per_page: 100, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
    }
  }

  async fetchCustomerSourceOptions(keyword) {
    if (keyword) {
      return (await this.$request.get('/customer_sources/read_options', { keyword, ...this.customerSourceOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
    } else {
      return (await this.$request.get('/customer_sources/read_options', { per_page: 100, ...this.customerSourceOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
    }
  }

  async fetchCustomerLevelOptions(keyword) {
    if (keyword) {
      return (await this.$request.get('/customer_levels/read_options', { keyword  })).data.map(item => ({ value: item.id, label: item.name }));
    } else {
      return (await this.$request.get('/customer_levels/read_options', { per_page: 100 })).data.map(item => ({ value: item.id, label: item.name }));
    }
  }

  async fetchCustomerTagOptions(keyword) {
    if (keyword) {
      return (await this.$request.get('/customer_tags/read_options', { keyword  })).data.map(item => ({ value: item.id, label: item.name }));
    } else {
      return (await this.$request.get('/customer_tags/read_options', { per_page: 100 })).data.map(item => ({ value: item.id, label: item.name }));
    }
  }

  async fetchCustomerBusinessModelOptions(keyword) {
    if (keyword) {
      return (await this.$request.get('/customer_business_models/read_options', { keyword  })).data.map(item => ({ value: item.id, label: item.name }));
    } else {
      return (await this.$request.get('/customer_business_models/read_options', { per_page: 100 })).data.map(item => ({ value: item.id, label: item.name }));
    }
  }

  async fetchShopOptions(keyword) {
    if (keyword) {
      return (await this.$request.get('/jushuitan_shops/read_options', { keyword  })).data.map(item => ({ value: item.shop_id, label: item.shop_name }));
    } else {
      return (await this.$request.get('/jushuitan_shops/read_options', { per_page: 100 })).data.map(item => ({ value: item.shop_id, label: item.shop_name }));
    }
  }

  sum(data) {
    return _.round(_.sum(_.map(_.values(data), _.toNumber)), 2)
  }

  get isOperator() {
    return ['salesman', 'customer_service', 'business_executive', 'channel_business_executive', 'finance_manager'].includes(this.roleKind)
  }

  get isAdmin() {
    return ['application'].includes(this.roleKind)
  }

  get noData() {
    return _.isEmpty(_.filter(_.values(this.data)))
  }

  formattedBarOptions(originData) {
    const legendData = Object.keys(originData);
    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        type: 'category',
        axisTick: { show: false },
        data: Object.keys(originData[legendData[0]])
      },
      yAxis: [
        {
          minInterval: 1,
          type: 'value',
        }
      ],
      series: _.map(_.map(originData), (element, index) => {
        return {
            name: legendData[index],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: index === 0 ? 'top' : 'insideTop',
              distance: 10,
              color: index === 0 ? colors[index] : '#000',
              formatter(param) {
                return Number(param.value) ? param.value : '';
              },
              fontSize: 14,
              fontWeight: 'bold',
            },
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: Object.values(element),
          }
      })
    })
  }

  formattedRatioOptions(originData) {
    const legendData = Object.keys(originData);
    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        type: 'category',
        axisTick: { show: false },
        data: Object.keys(originData[legendData[0]])
      },
      yAxis: [
        {
          minInterval: 1,
          type: 'value',
        }
      ],
      series: _.map(_.map(originData), (element, index) => {
        return {
            name: legendData[index],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: index === 0 ? 'top' : 'insideTop',
              distance: 10,
              color: index === 0 ? colors[index] : '#000',
              formatter(param) {
                return Number(param.value) ? (param.value * 100).toFixed(2) + '%' : '';
              },
              fontSize: 14,
              fontWeight: 'bold',
            },
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: Object.values(element),
          }
      })
    })
  }

  formattedPieOptions(originData, label) {
    if (!originData) {
      return null;
    }

    return {
      color: colors,
      legend: {
        top: '5%',
        left: 'center'
      },
      tooltip: {
        trigger: 'item'
      },
      series: [
        {
          name: label,
          type: 'pie',
          radius: '55%',
          label: {
            show: true,
            color: '#000',
            formatter(param) {
              return `${param.name} ${param.percent}%`
            }
          },
          data: _.map(originData, (value, key) => ({ name: key, value: value })),
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        },
      ]
    }
  }

  get timeRangeQuery() {
    const query = {};
    if (this.queryForm.created_gteq_date) {
      query.created_gteq_date = this.queryForm.created_gteq_date;
    }
    if (this.queryForm.created_lteq_date) {
      query.created_lteq_date = this.queryForm.created_lteq_date;
    }
    return query;
  }

  get jushuitanOrderQuery() {
    const query = _.merge(_.pickBy(this.queryForm, v => !_.isNil(v)), {
      related: true,
      status_in: ['Delivering', 'WaitConfirm', 'WaitFConfirm', 'Sent'],
      customer_id_not_null: true,
      user_id_eq: this.queryForm.customer_user_id_eq,
      sent_at_gteq_date: this.queryForm.created_gteq_date,
      sent_at_lteq_date: this.queryForm.created_lteq_date,
    });
    delete query.customer_user_id_eq;
    delete query.created_gteq_date;
    delete query.created_lteq_date;
    return query;
  }

  get jushuitanAfterSaleQuery() {
    return _.merge(_.pickBy(this.queryForm, v => !_.isNil(v)), {
      related: true,
      status_in: ['Confirmed'],
      ...this.timeRangeQuery,
    });
  }

  get customerQuery() {
    const result = _.pickBy({
      related: true,
      new_between: this.queryForm.created_gteq_date && this.queryForm.created_lteq_date ? [this.queryForm.created_gteq_date, this.queryForm.created_lteq_date] : undefined,
      id_eq: this.queryForm.customer_id_eq,
      user_id_eq: this.queryForm.customer_user_id_eq,
      customer_source_id_in: this.queryForm.customer_customer_source_id_in,
      customer_level_id_eq: this.queryForm.customer_customer_level_id_eq,
      customer_tags_id_eq: this.queryForm.customer_customer_tags_id_eq,
      customer_business_models_id_eq: this.queryForm.customer_customer_business_models_id_eq,
    }, v => !_.isNil(v))
    // 如果参数包含 new_between，则删除 related
    if (result.new_between) {
      delete result.related;
    }
    return result;
  }

  userColumns(key) {
    const labels = {
      followed_ratio: '触达率',
      average_spending_per_customer: '客单价',
      first_ordered_ratio: '新客首单转化率',
      more_ordered_ratio: '老客户复购率',
      ordered_ratio: '总转化率',
      order_amount: '订单金额',
      after_sale_amount: '售后金额',
    }

    // 触达率显示 分子 range_followed_customers_per_user， 分母 range_customers_per_user；
    // 新客首单转化率 分子 range_first_ordered_customers_per_user，分母 range_new_customers_per_user；
    // 老客户复购率 分子 range_more_ordered_customers_per_user，分母 range_customers_per_user - range_new_customers_per_user；
    // 总转化率 分子 range_ordered_customers_per_user，分母 range_customers_per_user
    return [
      ...userColumnsExtend(['screen_name']),
      {
        prop: key,
        label: labels[key],
        renderCell: (h, { props: { value, scope: { row } } }) => {
          if (key === 'followed_ratio') {
            const { range_followed_customers_per_user, range_customers_per_user } = this.statistics;
            const rangeFollowedCustomersPerUser = range_followed_customers_per_user[row.id].value || [];
            const rangeCustomersPerUser = range_customers_per_user[row.id].value || [];
            const notFollowedCustomers = _.differenceBy(rangeCustomersPerUser, rangeFollowedCustomersPerUser, 'id');

            const groups = [
              {
                title: '未触达',
                type: 'danger',
                list: notFollowedCustomers
              },
              {
                title: '已触达',
                type: 'success',
                list: rangeFollowedCustomersPerUser
              }
            ]

            return (
              <Result
                title={`${labels[key]} - ${row.screen_name}`}
                value={value}
                percentValue={true}
                groups={groups}

              />
            )
          }

          if (key === 'first_ordered_ratio') {
            const { range_first_ordered_customers_per_user, range_new_customers_per_user } = this.statistics;
            const rangeFirstOrderedCustomersPerUser = range_first_ordered_customers_per_user[row.id].value || [];
            const rangeNewCustomersPerUser = range_new_customers_per_user[row.id].value || [];
            const notFirstOrderedCustomers = _.differenceBy(rangeNewCustomersPerUser, rangeFirstOrderedCustomersPerUser, 'id');
            const groups = [
              {
                title: '未首单',
                type: 'danger',
                list: notFirstOrderedCustomers
              },
              {
                title: '已首单',
                type: 'success',
                list: rangeFirstOrderedCustomersPerUser
              }
            ]
            return (
              <Result
                title={`${labels[key]} - ${row.screen_name}`}
                value={value}
                percentValue={true}
                groups={groups}
              />
            )
          }

          if (key === 'more_ordered_ratio') {
            const { range_more_ordered_customers_per_user, range_customers_per_user, range_new_customers_per_user } = this.statistics;
            const rangeMoreOrderedCustomers = range_more_ordered_customers_per_user[row.id].value || [];
            const rangeCustomers = range_customers_per_user[row.id].value || [];
            const rangeNewCustomers = range_new_customers_per_user[row.id].value || [];

            const oldCustomers = _.differenceBy(rangeCustomers, rangeNewCustomers, 'id');
            const notRepurchasedCustomers = _.differenceBy(oldCustomers, rangeMoreOrderedCustomers, 'id');

            const groups = [
              {
                title: '未复购',
                type: 'danger',
                list: notRepurchasedCustomers
              },
              {
                title: '已复购',
                type: 'success',
                list: rangeMoreOrderedCustomers
              }
            ]
            return (
              <Result
                title={`${labels[key]} - ${row.screen_name}`}
                value={value}
                percentValue={true}
                groups={groups}
              />
            )
          }

          if (key === 'ordered_ratio') {
            const { range_ordered_customers_per_user, range_customers_per_user } = this.statistics;
            const orderedCustomers = range_ordered_customers_per_user[row.id].value || [];
            const rangeCustomers = range_customers_per_user[row.id].value || [];

            const notOrderedCustomers = _.differenceBy(rangeCustomers, orderedCustomers, 'id');

            const groups = [
              {
                title: '未转化',
                type: 'danger',
                list: notOrderedCustomers
              },
              {
                title: '已转化',
                type: 'success',
                list: orderedCustomers
              }
            ]
            return (
              <Result
                title={`${labels[key]} - ${row.screen_name}`}
                value={value}
                percentValue={true}
                groups={groups}
              />
            )
          }

          return <span>{_.includes(['average_spending_per_customer', 'order_amount', 'after_sale_amount'], key) ? value : `${(value * 100).toFixed(2)}%`}</span>
        }
      }
    ]
  }
}
</script>

<style lang="scss">
.dashboard-statistics-dialog-body {
  .group {
    margin-bottom: 20px;
  }

  .title {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>

<style lang="scss" scoped>
.statistics-info {
  font-size: 20px;
  color: #101ebf;
}
</style>
